export function clearMessage() {
    $('[id^="message"]').addClass("d-none").html("");
}
